import './text-quote.scss';
